<template>
	<div style="background-color: #fff;">
		<div class="header">
			<div class="header-title">{{content.title}}</div>
			<div class="header-time"><span>发布时间:{{content.releasetime}}</span></div>
		</div>
		<div class="content" v-html="content.content" v-loading="loading">
			
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import qs from 'qs';
	export default {
		data() {
			return {
				content:'',
				loading:true,
			}
		},
		created(){
			if(this.$route.query.buzType === undefined || this.$route.query.buzType === null || this.$route.query.buzType === ''){
				alert("参数无效；即将返回首页")
				this.$router.push({path:'/'}) 
			}else if(this.$route.query.titleId === undefined || this.$route.query.titleId === null || this.$route.query.titleId === ''){
				alert("参数无效；即将返回首页")
				this.$router.push({path:'/'}) 
			}else{
				this.getNewDetails(this.$route.query.buzType,this.$route.query.titleId);
			}
		},
		methods: {
			getNewDetails(buzType,titleId){
				  axios.post("/token/admin/huaxin/index",qs.stringify({
				  	data:{"buzType":buzType,"titleId":titleId},
				  	url:"appapi70002.json"
				  }))
				  .then(response => {
					  this.content =response.data.result[0]
					  while(response.data.result[0].content.indexOf("http://121.17.139.38:1080") != -1){
					      this.content.content=response.data.result[0].content.replace("http://121.17.139.38:1080","/api");
					  }
					  this.loading=false
				  })
				  .catch(function(error) {
				      // 请求失败处理
				      console.log(error);
				  });
			}
		}
	}
</script>

<style scoped>
	.header{
		/* height: 155px; */
		margin: 0 20px;
	}
	.header-title{
		/* height: 100px; */
		line-height: 50px;
		text-align: center;
		font-size: 25px;
		font-weight: 700;
	}
	.header-time{
		height: 45px;
		line-height: 45px;
		border-bottom: 3px solid #e9e9e9;
		text-align: right;
	}
	.header-time span{
		margin-right: 15%;
		font-size: 14px;
		color: #888;
	}
	.content {
		padding: 10px 20px;
	}
	.content >>> img{
		margin: 0 0;
		max-width: 100%;
	}
</style>